import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PartnershipForm from '../containers/PartnershipFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PartnershipAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PartnershipAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('partnership_route_add')} />
          <PartnershipForm/>
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PartnershipAddScreen;

Logger.log('silly', `PartnershipAddScreen loaded.`);
